import './expand-collapse-all.scss';
import FontBody2 from "../fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../fonts/font-props";

export interface IExpandCollapseAll {
    isAllExpanded?: boolean,
    onClick: () => void,
}

export const ExpandCollapseAll: React.FC<IExpandCollapseAll> = ({ isAllExpanded = true , onClick = () => { } }) => (
    <div className="expand-collapse-all">
        <div className='expand-collapse' onClick={() => onClick()}>
            <FontBody2 variant={FONT_VARIANT.DASHED} color={FONT_COLOR.PRIMARY3}>
                {isAllExpanded ? 'Collapse all' : 'Expand all'}
            </FontBody2>
        </div>
    </div>
);
